export type DownloadItem = {
  title: string
  type: string
  meta: string
  usage: string
  thumbnail: string
}

const portraitPrimary =
  'https://cdn.magicpatterns.com/uploads/mnZhzX2nqLH2XbADz2erb2/ASB_(9).png'
const portraitSigning =
  'https://cdn.magicpatterns.com/uploads/g3WiugGQPBDoopKz7uDstx/ASB_(8).png'
const rally =
  'https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg'
const volunteers =
  'https://cdn.magicpatterns.com/patterns/generated-images/ebf27f4b-fec1-4388-bbbb-126b7ec20001.jpg'
const townhall =
  'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg'

export const mediaAssets: DownloadItem[] = [
  {
    title: 'Official Portrait — High Resolution',
    type: 'JPG',
    meta: '4340 × 5790 px · 12.4 MB',
    usage: 'Editorial use. Do not crop the candidate out of context or apply filters.',
    thumbnail: portraitPrimary,
  },
  {
    title: 'Working Portrait — Desk Signing',
    type: 'JPG',
    meta: '4340 × 5790 px · 11.8 MB',
    usage: 'Editorial use with credit to the campaign photography team.',
    thumbnail: portraitSigning,
  },
  {
    title: 'Campaign Rally — Abuja, August 2026',
    type: 'JPG',
    meta: '3840 × 2160 px · 6.1 MB',
    usage: 'Editorial use. Caption must include date and location.',
    thumbnail: rally,
  },
  {
    title: 'Official Candidate Biography',
    type: 'PDF',
    meta: '4 pages · 480 KB · English',
    usage: 'Reproduce in full or quote with attribution.',
    thumbnail: townhall,
  },
  {
    title: 'Full Manifesto — “A Nigeria That Works”',
    type: 'PDF',
    meta: '96 pages · 8.2 MB · English',
    usage: 'Free to reproduce and distribute in full.',
    thumbnail: volunteers,
  },
  {
    title: 'Campaign Logo Pack',
    type: 'SVG + PNG',
    meta: 'ZIP · 2.4 MB',
    usage: 'Do not alter proportions or colours. Minimum clear space applies.',
    thumbnail: rally,
  },
]

export const resourceItems: DownloadItem[] = [
  {
    title: 'WhatsApp Status Graphics Pack',
    type: 'PNG',
    meta: '12 graphics · 1080 × 1920 · 4.1 MB',
    usage: 'Share freely. Do not add third-party branding.',
    thumbnail: volunteers,
  },
  {
    title: 'Ward Canvassing Poster',
    type: 'PDF',
    meta: 'A2 print-ready · 3.6 MB',
    usage: 'Print locally. Editable fields for ward and coordinator contact.',
    thumbnail: townhall,
  },
  {
    title: 'Volunteer Field Guide',
    type: 'PDF',
    meta: '24 pages · 1.9 MB',
    usage: 'For registered volunteers. Covers conduct, safety and voter education.',
    thumbnail: rally,
  },
  {
    title: 'Policy Explainer Cards',
    type: 'PNG',
    meta: '9 cards · square format · 5.3 MB',
    usage: 'One card per policy area. Facts sourced from the manifesto.',
    thumbnail: portraitSigning,
  },
  {
    title: 'Campaign Brand Guide',
    type: 'PDF',
    meta: '18 pages · 6.8 MB',
    usage: 'Colour, typography and logo usage rules for all campaign materials.',
    thumbnail: portraitPrimary,
  },
  {
    title: 'Two-Minute Manifesto Summary',
    type: 'PDF',
    meta: '2 pages · 320 KB · EN / HA / YO / IG',
    usage: 'Print and share. Available in four languages.',
    thumbnail: volunteers,
  },
]

export const manifestoFormats = [
  {
    title: 'The 2-minute summary',
    description: 'One page. The five commitments and how they will be measured.',
    meta: 'PDF · 320 KB · EN, HA, YO, IG',
    action: 'Read the summary',
  },
  {
    title: 'The 10-minute overview',
    description: 'Twelve pages covering each policy area, targets and funding logic.',
    meta: 'PDF · 1.4 MB · EN, HA',
    action: 'Read the overview',
  },
  {
    title: 'The full manifesto',
    description: 'Ninety-six pages, including the cost model and delivery framework.',
    meta: 'PDF · 8.2 MB · English',
    action: 'Download the manifesto',
  },
  {
    title: 'Watch the manifesto',
    description: 'A 24-minute filmed walkthrough with captions and sign language.',
    meta: 'Video · 24 min · captions',
    action: 'Watch now',
  },
  {
    title: 'Listen to the manifesto',
    description: 'Full audio edition for low-bandwidth listening and radio distribution.',
    meta: 'Audio · 1 hr 48 min',
    action: 'Listen now',
  },
  {
    title: 'Explore by topic',
    description: 'Jump straight to the policy area that affects you most.',
    meta: '9 policy areas',
    action: 'Open the agenda',
  },
]

export const pressContacts = [
  { role: 'Media enquiries', name: 'Ngozi Eze, Director of Communications', contact: 'press@bello2027.ng' },
  { role: 'Interview requests', name: 'Bookings desk', contact: 'interviews@bello2027.ng' },
  { role: 'Accreditation', name: 'Campaign press office', contact: 'accreditation@bello2027.ng' },
  { role: 'Policy briefings', name: 'Policy directorate', contact: 'policy@bello2027.ng' },
]
